import * as React from 'react';
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import useReduxState from 'src/hooks/useReduxState';

const ProductCompareClearAll = (props) => {
    const [showNoProductError, setNoProductError] = useReduxState(false, 'setNoProductError');

    const onClear = async () => {
        await new ProductCompareRepository().removeAll();
        // new BroadcastChannel('product-compare-toggled').postMessage({});
        await new ProductCompareRepository().fetchAllData();
        setNoProductError(true)
    }

    return (
        <>
            {props.type == 'button' ?
                <button className="bs5 btn btn-secondary"
                    onClick={async () => { onClear(); }} >CLEAR ALL</button>
                : <a href={'#'} className="compare-clear-link"
                    onClick={async (e) => {
                        e.preventDefault();
                        onClear();
                    }} >CLEAR ALL</a>
            }
        </>
    );
}

export default ProductCompareClearAll;